import { Route } from "react-router-dom";
import MainContacts from "../Views/Web/Contacts/MainContacts";
import {
  ConsultantsCreate,
  ConsultantsEdit,
  ConsultantsMain,
  ConsultantsView,
  IndexConsultants,
} from "../Views/Web/Contacts/Consultants";
import {
  IndexInstaller,
  InstallerCreate,
  InstallerEdit,
  InstallerMain,
  InstallerView,
} from "../Views/Web/Contacts/Installer";
import {
  IndexSupplier,
  SupplierCreate,
  SupplierEdit,
  SupplierMain,
  SupplierView,
} from "../Views/Web/Contacts/Suppliers";

import {
  ContractorsEdit,
  ContractorsCreate,
  ContractorsMain,
  ContractorsView,
  IndexContractors,
} from "../Views/Web/Contacts/MainContractors";

function ContactsRoutes() {
  return (
    <Route path="contacts" element={<MainContacts />}>
      <Route path="main-contractors" element={<ContractorsMain />}>
        <Route index element={<IndexContractors />} />
        <Route path="create" element={<ContractorsCreate />} />
        <Route path="edit/:contractorsEditId" element={<ContractorsEdit />} />
        <Route path="view/:contractorsViewId" element={<ContractorsView />} />
      </Route>
      <Route path="installers" element={<InstallerMain />}>
        <Route index element={<IndexInstaller />} />
        <Route path="create" element={<InstallerCreate />} />
        <Route path="edit/:installersEditId" element={<InstallerEdit />} />
        <Route path="view/:installersViewId" element={<InstallerView />} />
      </Route>
      <Route path="suppliers" element={<SupplierMain />}>
        <Route index element={<IndexSupplier />} />
        <Route path="create" element={<SupplierCreate />} />
        <Route path="edit/:suppliersEditId" element={<SupplierEdit />} />
        <Route path="view/:suppliersViewId" element={<SupplierView />} />
      </Route>
      <Route path="consultants" element={<ConsultantsMain />}>
        <Route index element={<IndexConsultants />} />
        <Route path="create" element={<ConsultantsCreate />} />
        <Route path="edit/:consultantsEditId" element={<ConsultantsEdit />} />
        <Route path="view/:consultantsViewId" element={<ConsultantsView />} />
      </Route>
    </Route>
  );
}

export default ContactsRoutes;